import { render, staticRenderFns } from "./FloatView.vue?vue&type=template&id=66c7f20e&"
import script from "./FloatView.vue?vue&type=script&lang=js&"
export * from "./FloatView.vue?vue&type=script&lang=js&"
import style0 from "./FloatView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports